import * as React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { UserInfo } from '../../../Login/common/defaults';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import { showLoadingWithMessage } from "../../../Application/redux-objects/actions";
import * as urls from "../../../shared/urls";
import Moment from 'moment';
import Datatable from "../../../DataTable";
import { IWorkflowStepDetails } from '../../common/types';
import { defaultDTOptions } from "../../../../common/defaults";
import { Button } from "react-bootstrap";
import { getTableValuesByGroupName } from "../../../../services/Utils/IndexedDBUtils";
import { PromiseSerial } from "../../../../services/Utils/JSUtils";

interface IFARSQueueControllerOwnProps {
    history:any;
    location:any;
}

interface IFARSQueueControllerPropsFromState {
    webServiceURL:string;
    currentUser:UserInfo;
    workflowStepsLoading:boolean;
    workflowSteps:IWorkflowStepDetails[];
}

interface IFARSQueueControllerPropsFromDispatch {
    showLoadingWithMessage: (show:boolean,message?:string) => void;
}

interface IFARSQueueControllerStateProps {
    data:any[];
    dataLoaded:boolean;
    componentReady:boolean;
    multiselectDataCache:any[];
}

type IFARSQueueControllerProps = IFARSQueueControllerOwnProps & IFARSQueueControllerPropsFromState & IFARSQueueControllerPropsFromDispatch;

class FARSQueueController extends React.Component<IFARSQueueControllerProps,IFARSQueueControllerStateProps> {
    // Private variables
    state = {
        data:[],
        dataLoaded:false,
        componentReady:false,
        multiselectDataCache:[]
    }
    
    farsQueueColumndDefs = [
        {
            targets: 0,
            orderable: false,
            createdCell: (td, cellData, rowData, row, col) => {
                return ReactDOM.render(
                    <React.Fragment>
                        <Button
                                variant='outline-primary'
                                size='sm'
                                data-id={cellData}
                                onClick={e => this.getReportImage(rowData)}
                            >
                                View Image
                        </Button>
                        <Button
                                variant='outline-secondary'
                                size='sm'
                                data-id={cellData}
                                onClick={e => this.removeItemFromQueue(cellData)}
                            >
                                Close
                        </Button>
                        
                    </React.Fragment>
                    ,
                    td
                );
            }
        }
    ];

    farsQueueColumns = [
        {
            title:"Actions",
            data: "id"
        },
        {
            title:"Date of Crash",
            mData: (data, type, dataToSet) => {
                return Moment(data.workflowItem.paperReport.keywords.dateOfCrash);
            }
        },
        {
            title:"Injury Status",
            mData: (data, type, dataToSet) => {
                return this.state.multiselectDataCache["InjuryStatus"].find(item => item.name == data.workflowItem.paperReport.keywords.injuryStatus).description;
            }
        },
        {
            title:"Non Motorist",
            mData: (data, type, dataToSet) => {
                return this.state.multiselectDataCache["YesNoUnknown"].find(item => item.name == data.workflowItem.paperReport.keywords.nonMotoristIndicator).description;
            }
        },
        {
            title:"County",
            data: "workflowItem.paperReport.keywords.county"
        }
    ];

    requiredGroups = [
        "InjuryStatus",
        "YesNoUnknown"
    ]

    queueStepName = "FARS"

    // Local methods
    
    getReportImage = (rowData:any) => {
        let pdfWindow = window.open('');
        pdfWindow.window.document.title = 'Print Notifications';
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(rowData.workflowItem.paperReport.pdf) +
            "'></iframe>"
        );
    }

    removeItemFromQueue = (id:number) => {
        Api.post(urls.COMPLETE_WORKFLOW_STEP, id)
            .then((response: ApiResponse<any>) => {
                if (response.ok)
                    this.setState({ data: this.state.data.filter(report => report.id != id)});
            });
    }

    populateDataFromIndexedDB = ():Promise<any> => {
        return Promise.all(this.requiredGroups.map(async groupName => {
            await getTableValuesByGroupName(groupName).then(result => { 
                let results = this.state.multiselectDataCache;
                results[groupName] = result;
                this.setState({ multiselectDataCache: results});
            })
        }));
    }

    loadComponentData = ():Promise<any> => {
        if (!this.state.dataLoaded && this.props.workflowSteps != null) {
            return Api.post(urls.GET_KEYWORDS_BY_WORKFLOW_STEP, (this.props.workflowSteps[this.queueStepName]))
                .then((response: ApiResponse<any>) => {
                    if (response.ok) {
                        this.setState({ data: response.data,dataLoaded:true}, () => Promise.resolve());
                    }
                });
        } 
    }

    showModal = ():Promise<any> => {
        this.props.showLoadingWithMessage(this.props.workflowStepsLoading,"Loading Queue Information ...");
        return new Promise(resolve => {
            let worflowStepLoadedCheck = setInterval(() => {
                if (!this.props.workflowStepsLoading && this.props.workflowSteps != null) {
                    this.props.showLoadingWithMessage(this.props.workflowStepsLoading);
                    clearInterval(worflowStepLoadedCheck);
                    resolve();
                }
            },100)     
        });
    }

    // Component LifeCycle methods
    componentDidMount() {
        this.setState({componentReady:false}, () => {
            PromiseSerial([this.showModal,this.populateDataFromIndexedDB,this.loadComponentData]).then(result => {
                this.setState({componentReady:true});
            })
        });
    }

    render() {
        return (
            <React.Fragment>
                {this.state.componentReady && (
                    <Datatable
                        {...defaultDTOptions}
                        id="tblFarsQueue"
                        data={this.state.data}
                        columns={this.farsQueueColumns}
                        columnDefs={this.farsQueueColumndDefs}
                    />
                )}
            </React.Fragment>
        );
  }
}


const mapStateToProps = (reduxState: any) => {
    return {
      webServiceURL: reduxState.Application.backendURL,
      currentUser: reduxState.Application.currentUser,
      workflowStepsLoading: reduxState.WorkflowQueues.WorkFlowStepsLoading,
      workflowSteps: reduxState.WorkflowQueues.WorkFlowSteps
    };
  };
  
  
  const mapDispatchToProps = {
    showLoadingWithMessage
  };

export default connect(mapStateToProps,mapDispatchToProps)(FARSQueueController);